import { render, staticRenderFns } from "./BooksInAcquisitionBatch.vue?vue&type=template&id=40c53fbc&scoped=true&"
import script from "./BooksInAcquisitionBatch.vue?vue&type=script&lang=js&"
export * from "./BooksInAcquisitionBatch.vue?vue&type=script&lang=js&"
import style0 from "./BooksInAcquisitionBatch.vue?vue&type=style&index=0&id=40c53fbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c53fbc",
  null
  
)

export default component.exports